import { Wifi, X } from "lucide-react"
import { Button } from "@/components/ui/button"
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select"

interface JobFiltersProps {
  jobType: string
  isRemote: boolean
  onJobTypeChange: (value: string) => void
  onRemoteChange: (value: boolean) => void
  onReset: () => void
}

export function JobFilters({ jobType, isRemote, onJobTypeChange, onRemoteChange, onReset }: JobFiltersProps) {
  const hasFilters = jobType !== "all" || isRemote

  return (
    <div className="flex flex-wrap items-center gap-3">
      <Select value={jobType} onValueChange={onJobTypeChange}>
        <SelectTrigger className="w-40">
          <SelectValue placeholder="Job type" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">All types</SelectItem>
          <SelectItem value="full-time">Full-time</SelectItem>
          <SelectItem value="part-time">Part-time</SelectItem>
          <SelectItem value="contract">Contract</SelectItem>
          <SelectItem value="freelance">Freelance</SelectItem>
        </SelectContent>
      </Select>

      <Button
        variant={isRemote ? "default" : "outline"}
        size="sm"
        onClick={() => onRemoteChange(!isRemote)}
        className={isRemote ? "bg-green-600 hover:bg-green-700" : ""}
      >
        <Wifi className="mr-1 h-4 w-4" />
        Remote
      </Button>

      {hasFilters && (
        <Button variant="ghost" size="sm" onClick={onReset}>
          <X className="mr-1 h-4 w-4" />
          Clear
        </Button>
      )}
    </div>
  )
}
